import React, { useState, useEffect, useCallback, useRef } from 'react';
import { NavigationButton } from 'components/buttons/Button';
import { CSSTransition } from 'react-transition-group';
import { useLocation, useNavigate } from 'react-router-dom';
import './styles.scss';

export default ({ icon, label, className, children, onClose = undefined, ...props }) => {
    const [open, setOpen] = useState(false);

    const onClick = useCallback(() => {
        setOpen(open => !open);
    }, [setOpen]);

    const ref = useRef();

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
            if (onClose) {
                onClose();
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside, true);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    });    

    const location = useLocation();
    const { pathname } = location;

    const navigate = useNavigate();
    useEffect(() => {
        setOpen(false);
    }, [pathname]);
    

    return (<div className={`zt-menubutton ${className || ''}`} ref={ref} {...props}>
        <NavigationButton icon={icon} onClick={onClick} selected={open}>{label}</NavigationButton>
        {open && 
            <CSSTransition in={true} appear={true} timeout={200} classNames="zt-menu__transition">
                <div className='zt-menubutton__content'>
                    {React.cloneElement(children, {onClose: () => setOpen(false)})}
                </div>
            </CSSTransition>
        }
    </div>);
}